const CURRENT_TENANT_UUID_STORAGE_KEY = 'currentTenantUuid';
const CURRENT_PARK_UUID_STORAGE_KEY = 'currentParkUuid';

type CurrentParkUuidMap = Record<string, string>;

const readCurrentParkUuidMap = (): CurrentParkUuidMap => {
  try {
    const raw = localStorage.getItem(CURRENT_PARK_UUID_STORAGE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }
    return Object.entries(parsed).reduce<CurrentParkUuidMap>(
      (result, [tenantUuid, parkUuid]) => {
        if (typeof parkUuid === 'string' && parkUuid) {
          result[tenantUuid] = parkUuid;
        }
        return result;
      },
      {},
    );
  } catch {
    return {};
  }
};

export const saveCurrentTenantUuid = (tenantUuid?: string | null) => {
  try {
    if (tenantUuid) {
      localStorage.setItem(CURRENT_TENANT_UUID_STORAGE_KEY, tenantUuid);
      return;
    }
    localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
    localStorage.removeItem(CURRENT_PARK_UUID_STORAGE_KEY);
  } catch {
    // ignore storage access errors
  }
};

export const readCurrentTenantUuid = () => {
  try {
    return localStorage.getItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const saveCurrentParkUuid = (
  tenantUuid: string,
  parkUuid?: string | null,
) => {
  try {
    const current = readCurrentParkUuidMap();
    if (parkUuid) current[tenantUuid] = parkUuid;
    else delete current[tenantUuid];
    localStorage.setItem(
      CURRENT_PARK_UUID_STORAGE_KEY,
      JSON.stringify(current),
    );
  } catch {
    // ignore storage access errors
  }
};

export const readCurrentParkUuid = (tenantUuid?: string | null) => {
  if (!tenantUuid) return null;
  return readCurrentParkUuidMap()[tenantUuid] || null;
};
